import React from 'react';
import { ChevronProps, ChevronView } from './Chevron.styles';

export const Chevron: React.FC<ChevronProps> = ({
  color = 'black',
  direction = 'right',
  size = 10,
  strokeWidth = 2,
  className,
}) => {
  return (
    <ChevronView
      color={color}
      direction={direction}
      size={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
};

export default Chevron;
